import React, { useContext } from "react"
import AddressBook from "../components/addressBook"
import AuditSearch from "../components/auditSearch"
import FormsLogo from "../images/efax.svg"
import "../css/style.css"
import Cookies from "js-cookie"
import { AuthContext } from "./../utils/authContext"

const Dashboard = () => {
  const { authUser } = useContext(AuthContext)

  // Pull token and ref for old ui link
  const raw = Cookies.get("auth")
  const parsed = JSON.parse(raw)

  const handleLogout = async () => {
    try {
      //await post(`/oauth/logout`)
      Cookies.remove("auth")
      //window.location.href = "http://localhost:3005/"
      window.location.href = "/"
    } catch (err) {
      console.error("Error in handleLogout:", err)
    }
  }

  return (
    <div className="container">
      <div className="header-container">
        <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Consensus Logo" />
          <div className="logo-label" style={{ color: "#000" }}>
            |
          </div>
          <div className="logo-label">Bulk Faxing</div>
        </div>

        <div className="user-container">
          {/* Temporary link  */}
          {/* <span style={{ marginRight: "10px", background: "yellow" }}>
            <a
              href={`https://demowar.loginbridge.net/main.html?ref=${btoa(
                parsed.faxNumber,
              )}&id=${parsed.accessToken}`}
              style={{
                margin: "12px",
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Return To Legacy
            </a>
          </span> */}
          {/* Temporary link  */}

          <span style={{ marginRight: "5px" }}>
            {" "}
            <a
              href={`/help`}
              target="_blank"
              style={{
                fontWeight: "bold",
                textDecoration: "none",
              }}
            >
              Help
            </a>{" "}
          </span>
          <span className="logout-link" onClick={() => handleLogout()}>
            Logout
          </span>
        </div>
      </div>
      <div className="container-fax">
        <AddressBook authUser={authUser} />
        <div className="fax-list">
          <AuditSearch authUser={authUser} />
        </div>
      </div>
    </div>
  )
}

export default Dashboard
